import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getCriticalCareSelector } from '../../procedures/criticalCare/selectors'
import { ICriticalCareState } from '../../procedures/criticalCare/store/criticalCare.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'

export function* addCriticalCareItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const criticalCareState: ICriticalCareState = yield select(getCriticalCareSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  const { pta, addToTimeline, action, site, key, time, date, assessedBy, comments, isEkgImport } = criticalCareState
  if (addToTimeline) {
    const clientCorrelationId = generateClientCorrelationId(
      nemsisCodeOptions,
      TimelineConstants.CRITICAL_CARE_PROCEDURE,
      null,
      {
        filter1: null,
        filter2: null,
        filter3: null,
      },
      key
    )
    const assessedByLabel = assessedBy?.name || ''
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Critical Care',
      eventSubHeader: `By ${assessedByLabel}, Action: ${action?.name || ''}, Site:
      ${site?.name?.toUpperCase() || ''}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_CRITICAL_CARE_PROCEDURE_ITEM,
      defaultHref: TabConstants.CRITICAL_CARE_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addCriticalCareItemSaga() {
  yield takeLatest([TimelineConstants.ADD_CRITICAL_CARE_ITEM], addCriticalCareItem)
}
